import angular from 'angular';
import * as html2pdf from 'html2pdf.js';
import { NsjRoutingType } from '../../core/nsj-core';

type DocumentoFop = {
    codigodocumento: string;
    nomedocumento: string;
    tenant: number;
};

export class RelatoriosService {

    static $inject = ['$q', '$http', '$uibModal', 'nsjRouting', 'NewToaster'];

    public busy = false;

    constructor(
        public $q: angular.IQService,
        public $http: angular.IHttpService,
        public $uibModal: ng.ui.bootstrap.IModalService,
        public nsjRouting: NsjRoutingType,
        public NewToaster: { pop: Function },
    ) {}

    baixarRelatorio(
        rota: string,
        constructors: object,
        callback: Function | null = null,
        useToaster: boolean = true
    ) {
        this.busy = true;

        if (useToaster) {
            this.showToaster('info', 'Buscando informações...');
        }

        this.$http.get<string>(
            this.nsjRouting.generate(rota, constructors, true),
            { responseType: 'arraybuffer' }
        ).then(response => {
            const a = document.createElement('html');
            a.setAttribute('id', 'htmlpdf');
            a.innerHTML = response.data;

            const opt = {
                margin: 1,
                filename: 'arquivo.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'in', orientation: 'portrait' }
            };

            html2pdf().set(opt).from(a).save();
            a.remove();
        }).catch(error => {
            if (error.data?.message) {
                this.showToaster('error', error.data.message);
            }
            console.error(error);
        }).finally(() => {
            if (typeof callback === 'function') {
                callback();
            }
            this.busy = false;
        });
    }

    baixarRelatorioPost(
        rota: string,
        constructors: object,
        callback: Function | null = null,
        useToaster: boolean = true
    ) {
        this.busy = true;

        if (useToaster) {
            this.showToaster('info', 'Buscando informações...');
        }

        this.$http.post<string>(
            this.nsjRouting.generate(rota, constructors, true),
            constructors
        ).then(response => {
            const a = document.createElement('html');
            a.setAttribute('id', 'htmlpdf');
            a.innerHTML = response.data;

            const opt = {
                margin: 1,
                filename: 'arquivo.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'in', orientation: 'portrait' }
            };

            html2pdf().set(opt).from(a).save();
            a.remove();
        }).catch(error => {
            if (error.data?.message) {
                this.showToaster('error', error.data.message);
            }
            console.error(error);
        }).finally(() => {
            if (typeof callback === 'function') {
                callback();
            }
            this.busy = false;
        });
    }

    baixarRelatorioFopPost(
        route: string,
        config: { useToaster?: boolean, fileName?: string, constructors: object },
        callback: Function | null = null
    ) {
        this.busy = true;

        if (config.useToaster) {
            this.showToaster('info', 'Buscando informações...');
        }

        this.$http.post<File>(
            this.nsjRouting.generate(route, config.constructors, true),
            config.constructors,
            { responseType: 'blob' }
        ).then(response => {
            const file = new Blob([response.data]);
            const fileURL = URL.createObjectURL(file);
            const a = document.createElement('a');

            document.body.appendChild(a);
            a.style.display = 'none';
            a.href = fileURL;
            a.download = this.getDownloadFileName(config.fileName, 'pdf');
            a.click();
            window.URL.revokeObjectURL(fileURL);
        }).catch(error => {
            if (error.data?.message) {
                this.showToaster('error', error.data.message);
            }
            console.error(error);
        }).finally(() => {
            if (typeof callback === 'function') {
                callback();
            }
            this.busy = false;
        });
    }

    baixarRelatorioFop(
        rota: string,
        constructors: { [key: string]: unknown },
        callback: Function | null = null,
        useToaster: boolean = true,
        fileName?: string
    ) {
        this.busy = true;

        if (useToaster) {
            this.showToaster('info', 'Buscando informações...');
        }

        if (rota === 'persona_trabalhadores_ponto') {
            const objTrabalhadores = !constructors.todos ? {
                trabalhadores: angular.copy(constructors.trabalhadores)
            } : {};
            delete constructors.trabalhadores;

            this.$http.post<File>(
                this.nsjRouting.generate(rota, constructors, true),
                objTrabalhadores,
                { responseType: 'blob' }
            ).then(response => {
                const file = new Blob([response.data], { type: 'application/octet-stream' });
                const fileURL = URL.createObjectURL(file);
                const a = document.createElement('a');

                document.body.appendChild(a);
                a.style.display = 'none';
                a.href = fileURL;
                a.download = this.getDownloadFileName(fileName, 'pdf');
                a.click();
                window.URL.revokeObjectURL(fileURL);
            }).catch(error => {
                if (error.data?.message) {
                    this.showToaster('error', error.data.message);
                }
                console.error(error);
            }).finally(() => {
                if (typeof callback === 'function') {
                    callback();
                }
                this.busy = false;
            });
        } else {
            this.$http.get<File>(
                this.nsjRouting.generate(rota, constructors, true),
                { responseType: 'blob' }
            ).then(response => {
                const file = new Blob([response.data], { type: 'application/octet-stream' });
                const fileURL = URL.createObjectURL(file);
                const a = document.createElement('a');

                document.body.appendChild(a);
                a.style.display = 'none';
                a.href = fileURL;
                a.download = this.getDownloadFileName(fileName, 'pdf');
                a.click();
                window.URL.revokeObjectURL(fileURL);
            }).catch(error => {
                if (error.data?.message) {
                    this.showToaster('error', error.data.message);
                }
                console.error(error);
            }).finally(() => {
                if (typeof callback === 'function') {
                    callback();
                }
                this.busy = false;
            });
        }
    }

    abrirRelatorioFop(
        rota: string,
        constructors: { [key: string]: unknown },
        callback: Function | null = null,
        useToaster: boolean = true
    ) {
        this.busy = true;

        if (useToaster) {
            this.showToaster('info', 'Buscando informações...');
        }

        if (rota === 'persona_trabalhadores_ponto') {
            const objTrabalhadores = { trabalhadores: angular.copy(constructors.trabalhadores) };
            delete constructors.trabalhadores;

            this.$http.post<File>(
                this.nsjRouting.generate(rota, constructors, true),
                objTrabalhadores,
                { responseType: 'blob' }
            ).then(response => {
                const file = new Blob([response.data], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                const uibModalInst = this.$uibModal.open({
                    animation: true,
                    keyboard: true,
                    backdrop: true,
                    template:
                        `<a id="closeModal" class="pull-right" style="margin-top: -30px;color: lightgray;cursor: pointer;" ng-click="ctrlModal.close()">
                            <i class="fas fa-times"></i>
                        </a>` +
                        '<embed src="' +
                        fileURL +
                        '" width="100%" height="100%" ng-init="ctrlModal.setStyle()"/>',
                    controller: function() {
                        const selfModal = this;
                        selfModal.setStyle = function() {
                            const modalDialog = document.getElementsByClassName('modal-dialog')[0] as HTMLElement;
                            const modalContent = document.getElementsByClassName('modal-content')[0] as HTMLElement;
                            modalDialog.style.width = '90%';
                            modalDialog.style.height = '90%';
                            modalContent.style.padding = '40px 20px 20px 20px';
                            modalContent.style.height = '100%';
                        };
                        selfModal.close = function() {
                            uibModalInst.close(false);
                        };
                    },
                    controllerAs: 'ctrlModal'
                });

                uibModalInst.result.then(() => {/* */}).catch(() => {/* */});
            }).catch(error => {
                if (error.data?.message) {
                    this.showToaster('error', error.data.message);
                }
                console.error(error);
            }).finally(() => {
                if (typeof callback === 'function') {
                    callback();
                }
                this.busy = false;
            });
        } else {
            this.$http.get<File>(
                this.nsjRouting.generate(rota, constructors, true),
                { responseType: 'blob' }
            ).then(response => {
                const file = new Blob([response.data], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                const uibModalInst = this.$uibModal.open({
                    animation: true,
                    keyboard: true,
                    backdrop: true,
                    template:
                        `<a id="closeModal" class="pull-right" style="margin-top: -30px;color: lightgray;cursor: pointer;" ng-click="ctrlModal.close()">
                            <i class="fas fa-times"></i>
                        </a>` +
                        '<embed src="' +
                        fileURL +
                        '" width="100%" height="100%" ng-init="ctrlModal.setStyle()"/>',
                    controller: function() {
                        const selfModal = this;
                        selfModal.setStyle = function() {
                            const modalDialog = document.getElementsByClassName('modal-dialog')[0] as HTMLElement;
                            const modalContent = document.getElementsByClassName('modal-content')[0] as HTMLElement;
                            modalDialog.style.width = '90%';
                            modalDialog.style.height = '90%';
                            modalContent.style.padding = '40px 20px 20px 20px';
                            modalContent.style.height = '100%';
                        };
                        selfModal.close = function() {
                            uibModalInst.close(false);
                        };
                    },
                    controllerAs: 'ctrlModal'
                });

                uibModalInst.result.then(() => {/* */}).catch(() => {/* */});
            }).catch(error => {
                if (error.data?.message) {
                    this.showToaster('error', error.data.message);
                }
                console.error(error);
            }).finally(() => {
                if (typeof callback === 'function') {
                    callback();
                }
                this.busy = false;
            });
        }
    }

    abrirRelatorio(
        rota: string,
        constructors: object,
        callback: Function | null = null,
        useToaster: boolean = false
    ) {
        this.busy = true;

        if (useToaster) {
            this.showToaster('info', 'Buscando informações...');
        }

        this.$http.get<File>(
            this.nsjRouting.generate(rota, constructors, true),
            { responseType: 'arraybuffer' }
        ).then(response => {
            const mimeType = response.headers('Content-Type');
            const file = new Blob([response.data], { type: mimeType });
            const fileURL = URL.createObjectURL(file);
            const uibModalInst = this.$uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: true,
                template:
                    `<a id="closeModal" class="pull-right" style="margin-top: -30px;color: lightgray;cursor: pointer;" ng-click="ctrlModal.close()">
                        <i class="fas fa-times"></i>
                    </a>` +
                    '<embed src="' +
                    fileURL +
                    '" width="100%" height="100%" ng-init="ctrlModal.setStyle()"/>',
                controller: function() {
                    const selfModal = this;
                    selfModal.setStyle = function() {
                        const modalDialog = document.getElementsByClassName('modal-dialog')[0] as HTMLElement;
                        const modalContent = document.getElementsByClassName('modal-content')[0] as HTMLElement;
                        modalDialog.style.width = '90%';
                        modalDialog.style.height = '90%';
                        modalContent.style.padding = '40px 20px 20px 20px';
                        modalContent.style.height = '100%';
                    };
                    selfModal.close = function() {
                        uibModalInst.close(false);
                    };
                },
                controllerAs: 'ctrlModal'
            });

            uibModalInst.result.then(() => {/* */}).catch(() => {/* */});
            this.showToaster('success', 'Arquivo gerado com sucesso!');
        }).catch(error => {
            if (error.data?.message) {
                this.showToaster('error', error.data.message);
            }
            console.error(error);
        }).finally(() => {
            if (typeof callback === 'function') {
                callback();
            }
            this.busy = false;
        });
    }

    listarDocumentosFop(entidade: string) {
        return this.$q<DocumentoFop[]>((resolve, reject) => {
            this.$http.get<DocumentoFop[]>(
                this.nsjRouting.generate('ns_documentosfop_indexagrupado', {
                    documentoentidade_entidade: entidade
                }, true)
            ).then((response) => {
                resolve(response.data);
            }).catch(response => reject(response));
        });
    }

    baixarPlanilhaXlsx(
        rota: string,
        constructors: object,
        callback: Function | null = null,
        fileName?: string
    ) {
        this.busy = true;

        this.$http.get<File>(
            this.nsjRouting.generate(rota, constructors, true), { responseType: 'arraybuffer' })
        .then(response => {
            const file = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const fileURL = URL.createObjectURL(file);

            // cria um link temporário para disparar o download
            const a = document.createElement('a');
            a.href = fileURL;

            a.download = this.getDownloadFileName(fileName, 'xlsx');

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            // libera a URL criada
            URL.revokeObjectURL(fileURL);

            this.showToaster('success', 'Arquivo gerado com sucesso!');
        }).catch(error => {
            if (error.data?.message) {
                this.showToaster('error', error.data.message);
            }
            console.error(error);
        }).finally(() => {
            if (typeof callback === 'function') {
                callback();
            }
            this.busy = false;
        });
    }

    private getDownloadFileName(fileName: string | undefined, extension: string): string {
        return fileName || `arquivo_download.${extension}`;
    }

    private showToaster(type: string, title: string) {
        this.NewToaster.pop({
            type: type,
            title: title
        });
    }
}

angular.module('main').service('RelatoriosService', RelatoriosService);
